(() => {
  const init = root => {
    if (root.dataset.nbDeliveryReady) return;
    root.dataset.nbDeliveryReady = 'true';
    const sync = () => {
      const show = root.dataset.nbCurrency === 'GBP' && root.dataset.nbCountry === 'GB' && Number(root.dataset.nbSellingTotal) > 4990;
      root.querySelectorAll('[data-nb-free-delivery]').forEach(block => {
        block.hidden = !show;
        const detail = block.closest('details');
        if (detail && detail.querySelector('.rte')?.children.length === 1) detail.hidden = !show;
      });
    };
    root.addEventListener('nb:selection-total', sync);
    sync();
  };
  const scan = () => document.querySelectorAll('[data-nb-new-uk]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
